import React, { useEffect, useState } from 'react';
import { useParams, Link, useLocation } from 'react-router-dom';
import { Table, Button, Row, Col, Input, DatePicker, message, Upload, InputNumber, Flex, Spin, Checkbox } from 'antd';
import APIService from '../../Service/APIService';
import FormConfig from '../../Config/FormConfig';
import { InboxOutlined, ExclamationCircleFilled, CheckCircleFilled, FileDoneOutlined, FilterOutlined, SortAscendingOutlined, SortDescendingOutlined, CloseCircleOutlined, LoadingOutlined, DeleteOutlined } from '@ant-design/icons';
import { Formik } from 'formik';
// import moment from 'moment';
import dayjs from 'dayjs';
import Swal from 'sweetalert2';
import './CommissionsCss.css';
import Select from 'react-select';
import CustomHeader from '../CustomHeader/CustomHeader';
import { set } from 'date-fns';
import { useNavigate } from 'react-router-dom';
import { useAuth } from "../AuthProvider";

const QuickUpdateCcp = () => {
  const navigate = useNavigate();
  const { id } = useParams(); // invoice id or commissioncontract id
  const { user } = useAuth();
  const [initialValues, setInitialValues] = useState(null);
  const [showLoader, setShowLoader] = useState(false);
  const [commContractOptions, setCommContractOptions] = useState([]);
  const [productGroupOptions, setProductGroupOptions] = useState([]);
  const [selectedProductGroup, setSelectedProductGroup] = useState({ label: '', value: '' });
  const [selectedCommContract, setSelectedCommContract] = useState({ label: '', value: '' });
  const [commissionPercentage, setCommissionPercentage] = useState(0);

  useEffect(() => {
    const userData = user;
    if (userData && userData?.Type != "Admin") {
      navigate("/");
    }
    if(!userData.IsSuperAdmin) {
      navigate("/");
    }
    getAllOptions().then((options) => {
      console.log("Options: ", options);
      const commContractOpts = options?.CommissionContracts?.map((item) => ({
        label: item.ID,
        value: item.ID
      })) || [];
      setCommContractOptions(commContractOpts);
      const productGroupOpts = options?.ProductGroups?.map((item) => ({
        label: item.ProductGroupName,
        value: item.ID
      })) || [];
      setProductGroupOptions(productGroupOpts);
    });
  }, [id]);

  const getAllOptions = async () => {
    const apiServe = new APIService();
    const response = await apiServe.getDataFromBackend("getquickccpoptions");
    return response?.data || {};
  }
  const [canBeAdded, setCanBeAdded] = useState(false);
  const checkProductInContract = async () => {
    setShowLoader(true);
    if (selectedCommContract?.value === "" || selectedProductGroup?.value === "") {
      message.error("Please select both Commission Contract and Product");
      setShowLoader(false);
      return;
    }
    const apiServe = new APIService();
    const response = await apiServe.getDataFromBackend(`CheckProductGroupInContract?ContractID=${selectedCommContract.value}&ProductGroupID=${selectedProductGroup.value}`);
    console.log("CheckProductInContract response: ", response);
    setShowLoader(false);
    if (response && response?.data && response?.data?.exists) {
      message.error("Product is already associated with this contract");
      setCanBeAdded(false);
    }
    else {
      message.success("Product can be added to this contract");
      setCanBeAdded(true);
    }
  }

  const handleSubmit = async () => {
    if (selectedCommContract?.value === "" || selectedProductGroup?.value === "" || commissionPercentage == 0 || commissionPercentage === "" || isNaN(commissionPercentage)) {
      message.error("Please fill all required fields");
      return;
    }
    setShowLoader(true);
    const apiServe = new APIService();
    const payload = {
      CommissionContractID: selectedCommContract?.value,
      ProductGroupID: selectedProductGroup?.value,
      ProductGroupName: selectedProductGroup?.label,
      CommissionPercentage: Number(commissionPercentage)
    }
    const response = await apiServe.addDataToBackend(payload, "quickupdateccp");
    if (response && response?.data && response?.status === 200) {
      setShowLoader(false);
      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: 'Product added to Commission Contract successfully',
        confirmButtonText: 'OK'
      }).then(() => {
        window.location.reload();
      });
    } else {
      setShowLoader(false);
      message.error("Something went wrong. Please try again.");
    }
  }

  return (
    <div>
      {showLoader &&
        <Spin fullscreen indicator={<LoadingOutlined style={{ fontSize: 48 }} spin />} />
      }
      <CustomHeader leftTopText="Welcome back!"
        leftBottomText={"Update Commission Contract Product"}
        rightTopText="Logged in as Admin"
        rightBottomText="User" />
      <div style={{ padding: '24px', background: '#fff', minHeight: 360, display: 'flex', flexDirection: 'column', gap: '24px' }}>
        <Row gutter={16}>
          <Col span={6} style={{ width: '100%' }}>
            <label className="form-label">Commission Contract ID<span style={{ color: 'red' }}>*</span></label>
            <Select
              // onBlur={() => formik.setFieldTouched("AccountID")}
              // title={formik.values["AccountID"]}
              value={selectedCommContract}
              // onChange={async (value, option) => {
              onChange={async (selectedOption) => {
                console.log("Value: ", selectedOption.value);
                console.log("Option: ", selectedOption);
                setSelectedCommContract(selectedOption);
                setCanBeAdded(false);
              }}
              // style={{ width: 120 }}
              style={{ width: '100%' }}
              defaultValue=""
              options={commContractOptions}
            />
          </Col>
          <Col span={6} style={{ width: '100%' }}>
            <label className="form-label">Product<span style={{ color: 'red' }}>*</span></label>
            <Select
              // onBlur={() => formik.setFieldTouched("AccountID")}
              // title={formik.values["AccountID"]}
              value={selectedProductGroup}
              // onChange={async (value, option) => {
              onChange={async (selectedOption) => {
                console.log("Value: ", selectedOption.value);
                console.log("Option: ", selectedOption);
                setSelectedProductGroup(selectedOption);
                setCanBeAdded(false);
              }}
              // style={{ width: 120 }}
              style={{ width: '100%' }}
              defaultValue=""
              options={productGroupOptions}
            />
          </Col>
          {canBeAdded && (
            <Col span={6}>
              <label className="form-label">Commission Percentage<span style={{ color: 'red' }}>*</span></label>
              <Input
                name="CommissionPercentage"
                value={commissionPercentage}
                onChange={(event) => setCommissionPercentage(event.target.value)}
              />
            </Col>
          )}
          <Col span={6} style={{ width: '100%' }}>
              <Button type="primary" style={{ marginTop: '30px' }} onClick={checkProductInContract}>Check</Button>
          </Col>
        </Row>
        {canBeAdded && (
          <Row gutter={16}>
            <Col span={6} style={{ width: '100%' }}>
              <Button type="primary" style={{ marginTop: '30px' }} onClick={handleSubmit}>Add to Contract</Button>
            </Col>
          </Row>
        )}
      </div>
    </div>
  )
}

export default QuickUpdateCcp;